import Cookies from 'js-cookie'

export default class MidtoneTexture {
	constructor() {
		this.minValue = 0;
		this.maxValue = 5;
		this.blockName = "midtoneTexture";
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		UI.removeBlockBlendingModes($(element));

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find(".midtone-texture_slider")
			.on("input", _ => this.sliderHandler($(element)));
		$(element)
			.find(".midtone-texture_range")
			.on("change", _ => this.inputHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: this.blockName,
			passes: [this.addPass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			values: {
				midtoneTexture: 0,
			},
		});

		if (!Cookies.get("acceptedNonExportableTool")) {
			UI.hideModal();
			UI.showModal(UI.modals.blocks.warnings.nonExportableTool);
		}
	}

	addPass() {
		let pass = gpu.createDitherPass();
		gpu.addPassToComposer(pass, "toMiddle");
		return pass;
	}

	sliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let sliderValue = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, sliderValue);

		let block = lutify.getActiveBlock();
		block.values.midtoneTexture = sliderValue;
		this.render(sliderValue);
	}

	inputHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let inputValue = UI.getAdjustmentBlock_rangeValue($el);

		if (inputValue > this.maxValue) {
			inputValue = this.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, inputValue);
		}
		if (inputValue < this.minValue) {
			inputValue = this.minValue;
			UI.setAdjustmentBlock_rangeValue($el, inputValue);
		}

		UI.setAdjustmentBlock_sliderValue($el, inputValue);
		lutify.getActiveBlock().values.midtoneTexture = inputValue;
		this.render(inputValue);
	}

	render(value) {
		lutify.getActiveBlock().passes[0].uniforms["midtoneTexture"].value = value;
		gpu.render();
	}

	applyChanges($block, values) {
		UI.setAdjustmentBlock_rangeValue($block, values.midtoneTexture);
		$block.find(".midtone-texture_range").trigger("change");
	}
}
